module.exports = __webpack_public_path__ + "static/media/Insync-Logo-New.70c5bd48.png";